import { css } from '@/styled-system/css';

export const container = css({
  display: 'flex',
  flexDirection: 'column',
});

export const websiteContainer = css({
  marginTop: '3x',
});

export const websiteLink = css({
  display: 'inline-flex',
  alignItems: 'center',
  gap: 'xs', // 4px
  fontSize: 'md',
  color: 'hpxTeal500',
  textDecoration: 'none',
  fontWeight: '500',

  _hover: {
    textDecoration: 'underline',
    color: 'hpxTeal600',
  },
});

export const externalIcon = css({
  width: '14px',
  height: '14px',
  marginLeft: 'xs',
});
